import { render } from "./HistoryView.vue?vue&type=template&id=8532baa2&scoped=true"
import script from "./HistoryView.vue?vue&type=script&lang=js"
export * from "./HistoryView.vue?vue&type=script&lang=js"

import "./HistoryView.vue?vue&type=style&index=0&id=8532baa2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8532baa2"]])

export default __exports__